module.exports = __webpack_public_path__ + "media/images/city/013-tomb-of-itimad-ud-daulah-5dfa818a50138923279746fdb776d176.svg";